/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';
import { NegozioDTO } from '../model/negozioDTO';
import { NegozioPublicDTO } from '../model/negozioPublicDTO';
import { NegozioStatsDTO } from '../model/negozioStatsDTO';
import { PageTransazioneInfoDTO } from '../model/pageTransazioneInfoDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class NegoziControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Torna la lista dei negozi per il tipo pratica ed il comune
     * @param id_slug_comune 
     * @param codice_pratica 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAll4(id_slug_comune: string, codice_pratica?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NegozioStatsDTO>>;
    public getAll4(id_slug_comune: string, codice_pratica?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NegozioStatsDTO>>>;
    public getAll4(id_slug_comune: string, codice_pratica?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NegozioStatsDTO>>>;
    public getAll4(id_slug_comune: string, codice_pratica?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAll4.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codice_pratica !== undefined && codice_pratica !== null) {
            queryParameters = queryParameters.set('codice_pratica', <any>codice_pratica);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NegozioStatsDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/negozi`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Torna la lista dei negozi per il tipo pratica ed il comune
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllPublic1(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<Array<NegozioPublicDTO>>;
    public getAllPublic1(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<NegozioPublicDTO>>>;
    public getAllPublic1(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<NegozioPublicDTO>>>;
    public getAllPublic1(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getAllPublic1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<NegozioPublicDTO>>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/negozi/info/public`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Torna le info del negozio associato all&#x27;utente (pensata per i cassieri)
     * @param id_slug_comune 
     * @param id_negozio 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNegozioInfoByUtente(id_slug_comune: string, id_negozio: string, observe?: 'body', reportProgress?: boolean): Observable<NegozioDTO>;
    public getNegozioInfoByUtente(id_slug_comune: string, id_negozio: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NegozioDTO>>;
    public getNegozioInfoByUtente(id_slug_comune: string, id_negozio: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NegozioDTO>>;
    public getNegozioInfoByUtente(id_slug_comune: string, id_negozio: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getNegozioInfoByUtente.');
        }

        if (id_negozio === null || id_negozio === undefined) {
            throw new Error('Required parameter id_negozio was null or undefined when calling getNegozioInfoByUtente.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id_negozio !== undefined && id_negozio !== null) {
            queryParameters = queryParameters.set('id_negozio', <any>id_negozio);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<NegozioDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/negozi/negozio/info`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Cpnsente di visualizzare le transazioni di un negozio
     * @param id_slug_comune 
     * @param page 
     * @param id 
     * @param size 
     * @param username 
     * @param dateFrom 
     * @param dateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTransazioniNegozio(id_slug_comune: string, page: number, id: string, size?: number, username?: string, dateFrom?: Date, dateTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<PageTransazioneInfoDTO>;
    public getTransazioniNegozio(id_slug_comune: string, page: number, id: string, size?: number, username?: string, dateFrom?: Date, dateTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageTransazioneInfoDTO>>;
    public getTransazioniNegozio(id_slug_comune: string, page: number, id: string, size?: number, username?: string, dateFrom?: Date, dateTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageTransazioneInfoDTO>>;
    public getTransazioniNegozio(id_slug_comune: string, page: number, id: string, size?: number, username?: string, dateFrom?: Date, dateTo?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getTransazioniNegozio.');
        }

        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling getTransazioniNegozio.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTransazioniNegozio.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (username !== undefined && username !== null) {
            queryParameters = queryParameters.set('username', <any>username);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageTransazioneInfoDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/negozi/${encodeURIComponent(String(id))}/transazioni`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
